import { t } from "../../i18n";
import { THEME_COLORS, type ThemeColor, type ThemePreference } from "../../storage";

type Props = {
  back: React.ReactNode;
  theme: ThemePreference;
  themeColor: ThemeColor;
  onThemeChange: (theme: ThemePreference) => void;
  onThemeColorChange: (color: ThemeColor) => void;
};

export function ThemePage({ back, theme, themeColor, onThemeChange, onThemeColorChange }: Props) {
  return (
    <section className="screen settings-screen" aria-labelledby="settings-heading">
      {back}
      <div className="screen-heading-row">
        <div>
          <h1 id="settings-heading">{t("Θέμα")}</h1>
          <p>{t("Χρώμα και λειτουργία εμφάνισης")}</p>
        </div>
      </div>

      <div className="settings-groups">
        <section className="settings-group">
          <h2>{t("Χρωματικό θέμα")}</h2>
          <label className="field">
            <select
              value={themeColor}
              onChange={(event) => onThemeColorChange(event.target.value as ThemeColor)}
              aria-label={t("Χρωματικό θέμα")}
            >
              {THEME_COLORS.map((entry) => (
                <option value={entry.value} key={entry.value}>
                  {entry.label}
                </option>
              ))}
            </select>
          </label>
        </section>

        <section className="settings-group">
          <h2>{t("Λειτουργία εμφάνισης")}</h2>
          <label className="field">
            <select
              value={theme}
              onChange={(event) => onThemeChange(event.target.value as ThemePreference)}
              aria-label={t("Λειτουργία εμφάνισης")}
            >
              <option value="system">{t("Αυτόματο")}</option>
              <option value="light">{t("Φωτεινό")}</option>
              <option value="dark">{t("Σκούρο")}</option>
            </select>
          </label>
        </section>
      </div>
    </section>
  );
}
